import { render } from "./SwitchDarkLightMode.vue?vue&type=template&id=610a890c&scoped=true"
import script from "./SwitchDarkLightMode.vue?vue&type=script&lang=js"
export * from "./SwitchDarkLightMode.vue?vue&type=script&lang=js"

import "./SwitchDarkLightMode.vue?vue&type=style&index=0&id=610a890c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610a890c"]])

export default __exports__